import { withApiBaseUrl } from '../lib/apiBaseUrl'
import { getTenantId as resolveTenantId } from '../utils/tenantUtils'
import { handleSessionReplaced } from '../utils/sessionReplacedHandler'
import {
  isMonthlyRewardTabUnavailableMessage,
  MONTHLY_REWARD_UNAVAILABLE_TEXT,
} from '../utils/monthlyRewardTabs'

function getAccessToken(): string | null {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken')
}

function getCurrentUser(): { tenantId?: string } | null {
  try {
    const localUser = localStorage.getItem('user')
    if (localUser) return JSON.parse(localUser)
    const sessionUser = sessionStorage.getItem('user')
    return sessionUser ? JSON.parse(sessionUser) : null
  } catch {
    return null
  }
}

function getTenantIdForRequest(): string {
  return resolveTenantId(getCurrentUser())
}

export type MonthlyRewardTabKey = 'cashback' | 'loss' | 'refer' | 'rank'

export interface MonthlyRewardItem {
  rank: number
  user: string
  metricValue: string
  reward: string
  source: 'real' | 'fake'
}

export interface MonthlyRewardResponse {
  success: boolean
  data?: {
    tab: MonthlyRewardTabKey
    monthLabel: string
    pageTitle: string
    subtitle: string
    title: string
    metricLabel: string
    rewardLabel: string
    emptyText: string
    items: MonthlyRewardItem[]
    summary?: {
      realCount: number
      fakeCount: number
      rowsPerTab: number
    }
    updatedAt?: string | null
    updatedBy?: string | null
  }
  message?: string
}

export async function getMonthlyRewardBoard(tab: MonthlyRewardTabKey): Promise<MonthlyRewardResponse> {
  const token = getAccessToken()
  const tenantId = getTenantIdForRequest()
  const res = await fetch(withApiBaseUrl(`/api/v1/user-auth/monthly-rewards/${tab}`), {
    method: 'GET',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
    },
    credentials: 'include',
  })

  const data = await res.json().catch(() => ({ success: false, message: 'Invalid monthly reward response' }))
  if (res.status === 401 && (data as any)?.code === 'SESSION_REPLACED') {
    await handleSessionReplaced()
    throw new Error('SESSION_REPLACED')
  }
  if (
    res.status === 404 &&
    isMonthlyRewardTabUnavailableMessage((data as MonthlyRewardResponse)?.message)
  ) {
    return {
      success: true,
      data: {
        tab,
        monthLabel: 'เดือนปัจจุบัน',
        pageTitle: 'รางวัลประจำเดือน',
        subtitle: '',
        title: 'รางวัลประจำเดือน',
        metricLabel: '',
        rewardLabel: '',
        emptyText: MONTHLY_REWARD_UNAVAILABLE_TEXT,
        items: [],
      },
    }
  }
  if (!res.ok) {
    throw new Error((data as any)?.message || `HTTP ${res.status}`)
  }
  return data as MonthlyRewardResponse
}
